export const validateMessageTranslation = function (error: string, t: any) {
  const parts = String(error!).split(':');
  let template = t(String(parts.shift()));
  for (const i in parts) {
    template = template.replace('$' + (Number(i) + 1), parts[i]);
  }
  return template;
};
